






























import { defineComponent } from "@vue/composition-api";
import { getElement } from "@/lib/elementHelpers";

export default defineComponent({
  name: "BaseCheckbox",
  props: {
    checked: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    hideIcon: { type: Boolean, default: false },
    checkedBoxColor: { type: String, default: "var(--palette-gray-lighten-7)" },
  },
  model: {
    event: "input",
    prop: "checked",
  },
  methods: {
    click() {
      (getElement(this.$refs.checkbox) as HTMLInputElement).click();
    },
  },
});
